import { _decorator } from 'cc';
import BaseHistoryRecord from './BaseHistoryRecord';
import MultiThemeSource from '../../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';
import { JackpotLevel } from '../../../../../../tableEngine/Script/Game/Data/Model/LobbyJackpotModel';
import InGameJackpotHistoryData from '../../../../Data/DataObject/History/InGameJackpotHistoryData';

const { ccclass, property } = _decorator;

@ccclass('JackpotHistoryRecord')
export default class JackpotHistoryRecord extends BaseHistoryRecord {
    @property(MultiThemeSource)
    private readonly jackpotThemeSource: MultiThemeSource = null;

    protected declare historyData: InGameJackpotHistoryData;

    public updateContent() {
        this.jackpotThemeSource.theme = JackpotLevel.list().indexOf(this.historyData.level);
        this.timeLabel.time = this.historyData.timestamp;
        this.updateProfitOrLoss(this.historyData.win - this.historyData.bet);
        // hide the machine info label until the machine name is loaded
        this.machineInfoLabel.updateInfo(this.historyData.machineID, this.historyData.machineName);
    }
}
